import { render, staticRenderFns } from "./ValutationBrandAmbassador.vue?vue&type=template&id=10da44f5&"
import script from "./ValutationBrandAmbassador.vue?vue&type=script&lang=js&"
export * from "./ValutationBrandAmbassador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports